import { render, staticRenderFns } from "./visitor.vue?vue&type=template&id=2b5714b6&scoped=true&"
import script from "./visitor.vue?vue&type=script&lang=js&"
export * from "./visitor.vue?vue&type=script&lang=js&"
import style0 from "./visitor.vue?vue&type=style&index=0&id=2b5714b6&lang=less&scoped=true&"
import style1 from "./visitor.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5714b6",
  null
  
)

export default component.exports